import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

export const TEAM_SIGNUP_STEPS = ['Select Plan', 'Build Team', 'Make Payment'];
export const USER_SIGNUP_STEPS = ['Accept Terms', 'Create Password', 'Welcome to Calculist!'];

interface SignupProgressProps {
    /** 1-based index of the currently active step */
    currentStep: number;
    /** Optional steps array; defaults to the 8-step self-service flow */
    steps?: string[];
}

export const SignupProgress: React.FC<SignupProgressProps> = ({ currentStep, steps = TEAM_SIGNUP_STEPS }) => {
    const theme = useTheme();
    const label = steps[currentStep - 1] ?? '';
    const pct = Math.round((currentStep / steps.length) * 100);

    return (
        <div style={{ marginBottom: theme.spacing.xl }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'baseline',
                marginBottom: '10px',
            }}>
                <span style={{
                    fontSize: theme.typography.fontSize.lg,
                    fontWeight: theme.typography.fontWeight.semibold,
                    color: theme.colors.text.primary,
                }}>
                    {label}
                </span>
                <span style={{
                    fontSize: theme.typography.fontSize.sm,
                    fontWeight: 500,
                    color: theme.colors.text.muted,
                }}>
                    Step {currentStep} of {steps.length}
                </span>
            </div>
            <div style={{
                width: '100%',
                height: '8px',
                backgroundColor: theme.colors.border.default,
                borderRadius: '999px',
                overflow: 'hidden',
            }}>
                <div style={{
                    width: `${pct}%`,
                    height: '100%',
                    backgroundColor: theme.colors.primary,
                    borderRadius: '999px',
                    transition: 'width 0.3s ease',
                }} />
            </div>
        </div>
    );
};
